import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=24f10d44&scoped=true"
import script from "./Exam.vue?vue&type=script&lang=js"
export * from "./Exam.vue?vue&type=script&lang=js"
import style0 from "./Exam.vue?vue&type=style&index=0&id=24f10d44&prod&lang=scss&scoped=true"
import style1 from "./Exam.vue?vue&type=style&index=1&id=24f10d44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f10d44",
  null
  
)

export default component.exports